import { InjectionToken } from '@angular/core';

export const BUTTON_LINK_ICON = new InjectionToken<string | null>(
  'BUTTON_LINK_ICON',
  {
    providedIn: 'root',
    factory: () => null,
  },
);
export const EXTERNAL_LINK_ICON = new InjectionToken<string | null>(
  'EXTERNAL_LINK_ICON',
  {
    providedIn: 'root',
    factory: () => null,
  },
);
export const INTERNAL_LINK_ICON = new InjectionToken<string | null>(
  'INTERNAL_LINK_ICON',
  {
    providedIn: 'root',
    factory: () => null,
  },
);
